/* eslint-disable max-len */
import { isObject } from 'lodash/fp';
import { useCallback } from 'react';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { useDeleteVariantConfiguratorMatrixAssetMutation } from '../../../../api/mutations/deleteVariantConfiguratorMatrixAsset';
import { useUploadVariantConfiguratorMatrixAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorMatrixAsset';
import { MatrixAsset } from '../../../../api/types';

const useHandleTrimMatrixAsset = () => {
    const [uploadTrimMatrixAssetMutation] = useUploadVariantConfiguratorMatrixAssetMutation();
    const [deleteTrimMatrixAssetMutation] = useDeleteVariantConfiguratorMatrixAssetMutation();

    const uploadTrimMatrixAsset = useCallback(
        async (variantConfiguratorId: string, colorId: string, trimId: string, upload: File) => {
            const { data } = await uploadTrimMatrixAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    colorId,
                    trimId,
                    type: MatrixAsset.TrimImage,
                    upload,
                },
            });

            return data?.variantConfigurator?.trimBlock;
        },
        [uploadTrimMatrixAssetMutation]
    );

    const deleteTrimMatrixAsset = useCallback(
        async (variantConfiguratorId: string, colorId: string, trimId: string) => {
            const { data } = await deleteTrimMatrixAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    colorId,
                    trimId,
                    type: MatrixAsset.TrimImage,
                },
            });

            return data?.variantConfigurator?.trimBlock;
        },
        [deleteTrimMatrixAssetMutation]
    );

    return useCallback(
        async (
            variantConfiguratorId: string,
            colorId: string,
            trimId: string,
            upload: File | UploadFileWithPreviewFormDataFragment,
            initialVariantTrimImage?: UploadFileWithPreviewFormDataFragment
        ) => {
            if (upload instanceof File) {
                await uploadTrimMatrixAsset(variantConfiguratorId, colorId, trimId, upload);
            }

            if (!upload && isObject(initialVariantTrimImage)) {
                await deleteTrimMatrixAsset(variantConfiguratorId, colorId, trimId);
            }
        },
        [deleteTrimMatrixAsset, uploadTrimMatrixAsset]
    );
};

export default useHandleTrimMatrixAsset;
